// extracted by mini-css-extract-plugin
module.exports = {"menu":"dialog-dropdown_menu__2tO9O"};